/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import can from 'can';
import template from './putts.stache';

Component.extend({
    tag: 'leaderboard-statistic-putts',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            round: {
                type: 'number',
                value: 1,
            },
            player: {
                Type: can.Map,
            },
            stats: {
                get() {
                    let roundInfo = this.attr('round')
                        ? this.attr(
                              `player.roundsInfo.${this.attr('round') -
                                  1}.stats`,
                          )
                        : this.attr('player.overallStats');
                    roundInfo = roundInfo
                        ? roundInfo
                              .filter((stat) => stat.name === 'Number of Putts')
                              .pop() || new can.Map({})
                        : new can.Map({});

                    return {
                        statNumber: roundInfo.attr('total') || 0,
                        statRank: roundInfo.attr('rank') || 0,
                        playerStat: roundInfo.attr('stat.value') || 0,
                        fieldStat: roundInfo.attr('average.value') || 0,
                    };
                },
            },
        },
    },
    events: {},
});
